import { configureStore } from '@reduxjs/toolkit';
import companySlice from './companySlice'
import adminProgramSlice from './adminProgramSlice';
import programCategoriesSlice from './programCategoriesSlice';
import userProgramSlice from './userProgramSlice';
import allVideosSlice from './allVideosSlice';
import userSlice from './userSlice';
import copiedExerciseSlice from './copiedExerciseSlice';

const rootReducer = {
  company: companySlice.reducer,
  adminProgram: adminProgramSlice.reducer,
  userProgram: userProgramSlice.reducer,
  programCategories: programCategoriesSlice.reducer,
  allVideos: allVideosSlice.reducer,
  user: userSlice.reducer,
  copiedExercise: copiedExerciseSlice.reducer
}

// Create a new Redux store using configureStore
export const store = configureStore({
  reducer: rootReducer,
});


